export enum LinkImportStatus {
  Success = 0,
  PartialError = 1,
  Error = 2,
}

export interface LinkImportLogsResponse {
  totalRecords: number;
  linkImportLogs: LinkImportLogDetails[];
}

export interface LinkImportLogDetails {
  importId: string;
  userId: number;
  importDate: string;
  importTime: string;
  status: LinkImportStatus | number | string;
  errorFileName?: string | null;
  toolId?: string | null;
}
